<template>
  <div>
    <card-maker
      :infos="infos"
      :cardColor="cardColor"
      :stripColor="stripColor"
      :buttonColor="buttonColor"
      :textColor="textColor"
      :numberShow="true"
    ></card-maker>
  </div>
</template>

<script>
import CardMaker from "@/view/components/Product/cardMakr";

export default {
  name: "productUi",
  components: { CardMaker },
  data() {
    return {
      cardColor: "#0f2a61",
      stripColor: "#61a5c2",
      buttonColor: "#0f2a61",
      textColor: "#61a5c2",
    };
  },
  computed: {
    infos() {
      const localeMap = {
        fa: "fa-IR",
        en: "en-US",
        ar: "ar-SA",
      };
      const currencyMap = {
        fa: "IRR",
        en: "IRR",
        ar: "IRR",
      };
      const currentLocale = this.$i18n.locale;
      return [
        {
          src: "https://avatars.mds.yandex.net/i?id=8648563d405d8dd8bbbacb222905a800282afc62-8307637-images-thumbs&n=13",
          title: this.$t("headphone_title"),
          price: this.formatPrice(
            2500000,
            currencyMap[currentLocale],
            localeMap[currentLocale]
          ),
          url: "",
          btnText: this.$t("buy_button"),
        },
      ];
    },
  },
  methods: {
    formatPrice(amount, currency, locale) {
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency,
      }).format(amount);
    },
  },
};
</script>
